import "./SuccessView.css";

interface SuccessViewProps {
  title: string;
  message: string;
  submessage: string;
  resetButtonText?: string;
  onReset: () => void;
}

export function SuccessView({
  title,
  message,
  submessage,
  resetButtonText,
  onReset,
}: SuccessViewProps) {
  return (
    <div className="success-wrapper-modern">
      <div className="success-icon-ring">
        <svg
          className="checkmark"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 52 52"
        >
          <circle
            className="checkmark__circle"
            cx="26"
            cy="26"
            r="25"
            fill="none"
          />
          <path
            className="checkmark__check"
            fill="none"
            d="M14.1 27.2l7.1 7.2 16.7-16.8"
          />
        </svg>
      </div>
      <h2 className="success-title">{title}</h2>
      <p className="success-message">{message}</p>
      <p className="success-submessage">{submessage}</p>
      {resetButtonText && (
        <button onClick={onReset} className="btn btn-filled btn-reset-modern">
          {resetButtonText}
        </button>
      )}
    </div>
  );
}
